@if (visTittel) {
  <mat-toolbar color="primary">
    {{ riktekstRedigeringParametre.tittel }}

    <button mat-stroked-button
            type="button"
            (click)="lukk()"
            class="lukk-fullskjermvisning"
            matTooltip="{{'Lukk fullskjermvisning' | translate}}"
            data-testid="lukk-fullskjermvisning-knapp">
      <mat-icon>close_fullscreen</mat-icon>
      {{'Minimer'|translate}}
    </button>
  </mat-toolbar>
  <!--<h2 mat-dialog-title id="riktekst-redigering-fullskjermmodal-dialog-tittel">{{ riktekstRedigeringParametre.tittel }}</h2>-->
}
<mat-dialog-content>
  <riktekst-redigering [gruppeId]="riktekstRedigeringParametre.gruppeId"
                       [skjemakontroll]="riktekstRedigeringParametre.skjemakontroll"
                       [innholdBrukesIPdf]="riktekstRedigeringParametre.innholdBrukesIPdf"
                       menylinjeKunVedAktiv="false"
                       visAlleFormateringsvalg="true"
                       erFullskjermvisning="true"
                       (vedLukkFullskjermvisning)="lukk()"/>
</mat-dialog-content>
